import React from 'react';

import * as S from './styles';

const Card: React.FC = ({ children }) => {
  return <S.Container className='mt-4'>{children}</S.Container>;
};

export default Card;
